// All API monetary amounts are integer cents. Calendar time is Europe/Berlin.
export function calculateIncome(data, now, mode = 'total') {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
    timeZone:'Europe/Berlin', year:'numeric', month:'numeric', day:'numeric',
    hour:'numeric', minute:'numeric', second:'numeric', hourCycle:'h23'
  }).formatToParts(now).map(p => [p.type,p.value]));
  const year = Number(parts.year), month = Number(parts.month)-1, day = Number(parts.day);
  if (year !== data.year) throw new Error('Für ' + year + ' sind noch keine passenden Jahresdaten eingerichtet.');
  if (!Array.isArray(data.months) || data.months.length !== 12 || !data.months.every(m => Number.isSafeInteger(m.active) && Number.isSafeInteger(m.passive))) throw new Error('Ungültige Monatsdaten.');
  const amount = m => mode === 'active' ? m.active : mode === 'passive' ? m.passive : m.active + m.passive;
  const days = new Date(Date.UTC(year,month+1,0)).getUTCDate();
  // Equal calendar-day allocation: on DST days the display follows local wall time.
  const fraction = (Number(parts.hour)*3600 + Number(parts.minute)*60 + Number(parts.second))/86400;
  const monthly = amount(data.months[month])/100, daily = monthly/days;
  const today = daily*fraction, mtd = daily*(day-1)+today;
  return {today, mtd, ytd:data.months.slice(0,month).reduce((sum,m) => sum+amount(m)/100,0)+mtd,
    daily, monthly, annual:data.months.reduce((sum,m) => sum+amount(m)/100,0),
    monthName:new Intl.DateTimeFormat('de-DE',{month:'long',timeZone:'Europe/Berlin'}).format(now)};
}
